"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSelect = void 0;
var _Select = require("./Select");
// TODO: in v9, move styled() from Select.jsx to here
var StyledSelect = _Select.Select;
exports.StyledSelect = StyledSelect;